import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-confirm-check-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [class]="iconClass()">
      <rect
        [attr.width]="width()"
        [attr.height]="height()"
        [attr.rx]="rx()"
        [attr.fill]="bgColor()" />
      <path
        d="M24 14C18.49 14 14 18.49 14 24C14 29.51 18.49 34 24 34C29.51 34 34 29.51 34 24C34 18.49 29.51 14 24 14ZM28.78 21.7L23.11 27.37C22.97 27.51 22.78 27.59 22.58 27.59C22.38 27.59 22.19 27.51 22.05 27.37L19.22 24.54C18.93 24.25 18.93 23.77 19.22 23.48C19.51 23.19 19.99 23.19 20.28 23.48L22.58 25.78L27.72 20.64C28.01 20.35 28.49 20.35 28.78 20.64C29.07 20.93 29.07 21.4 28.78 21.7Z"
        [attr.fill]="color()" />
    </svg>
  `,
})
export class ConfirmCheckIconComponent extends BaseIconComponent {
  override width = input<string>('48');
  override height = input<string>('48');
  override viewBox = input<string>('0 0 48 48');
  override color = input<string>('#EF4444');

  /** Border radius for the background rect (half of width for circle) */
  readonly rx = input<string>('24');

  /** Background color of the circle */
  readonly bgColor = input<string>('#FEF2F2');
}
